<template>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    // ...mapActions(["GET_CUSTOMERS"])
  },
  data() {
    return {
      //   Customers: [],
      //   CustomerHeaders: [
      //     { text: "KundeId", value: "id", sortable: true },
      //     { text: "Navn", value: "Label", sortable: true },
      //     {
      //       text: "Antall Organisasjoner",
      //       sortable: false
      //     },
      //     {}
      //   ]
    };
  },
  mounted() {
    // this.GET_CUSTOMERS()
    //   .then(resp => {
    //     this.Customers = resp.data.customers;
    //   })
    //   .catch(ex => {
    //     console.error(ex);
    //   });
  }
};
</script>
